<template>
  <v-tooltip>
    <template #activator="{ props }">
      <v-icon
        v-bind="props"
        :class="$attrs.class"
        class="handle"
        style="cursor: pointer"
        color="grey-darken-2"
        :icon="icon"
        :size="iconSize"
      />
    </template>
    <div :style="{ maxWidth: `${width}px`}">
      <slot />
    </div>
  </v-tooltip>
</template>

<script lang="ts" setup>
interface Props {
  iconSize?: number
  width?: number
  icon?: string
}

const {
  iconSize = 22,
  width = 400,
  icon = 'fa-regular fa-circle-question',
} = defineProps<Props>()

</script>
